module.exports = __webpack_public_path__ + "static/img/icon-add1.247467b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-add1.jpg
// module id = LAUr
// module chunks = 1